import { runDemo } from "../shared/demoRunner";
import { createBones2TestScene } from "./scene";

runDemo({ createScene: createBones2TestScene });
